import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreatePrivateLessonBooking } from "../api/queries";
import { BookingCreateForm } from "../ui/BookingCreateForm";

export function PrivateLessonBookingCreatePage() {
  const nav = useNavigate({ from: "/app/private-lessons/bookings/create" });
  const search = useSearch({ from: "/app/private-lessons/bookings/create" });
  const createBooking = useCreatePrivateLessonBooking();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ການຈອງຮຽນສ່ວນຕົວ", to: "/app/private-lessons/bookings" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ຈອງຮຽນສ່ວນຕົວ
            </h2>
            <p className="text-muted-foreground">ສ້າງການຈອງຮຽນສ່ວນຕົວໃໝ່</p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => nav({ to: "/app/private-lessons/bookings/bulk-create" })}
            >
              ຈອງຫຼາຍຄັ້ງ
            </Button>
            <Button
              variant="outline"
              onClick={() => nav({ to: "/app/private-lessons/bookings" })}
            >
              <ArrowLeftIcon className="size-4" />
              ກັບຄືນ
            </Button>
          </div>
        </div>

        <div className="mt-6">
          <BookingCreateForm
            initialStudentId={
              typeof search.studentId === "string"
                ? search.studentId
                : undefined
            }
            initialPackageId={
              typeof search.packageId === "string"
                ? search.packageId
                : undefined
            }
            onSubmit={async (vals) => {
              try {
                const result = await createBooking.mutateAsync(vals);
                nav({
                  to: "/app/private-lessons/bookings/$id",
                  params: { id: result.id },
                });
              } catch {
                // Error handling is done by the mutation
              }
            }}
            onSubmitAndStay={async (vals) => {
              try {
                await createBooking.mutateAsync(vals);
              } catch {
                // Error handling is done by the mutation
              }
            }}
            submitting={createBooking.isPending}
          />
        </div>
      </Main>
    </>
  );
}
